import './uploadProgress.scss';
import { lang } from '@umu/ukit-lang';
import React, { useEffect, useState } from 'react';

function UploadProgress(props: { label?: string; rate: number }) {
    const [count, setCount] = useState(props.rate);

    useEffect(() => {
        setCount(props.rate);
    }, [props.rate]);
    return (
        <div className="upload-progress-rate">
            <div className="tips">{props.label || lang('数据上传中，请不要关闭页面')}</div>
            <div className="progress-bar">
                <div className="progress-bar-inner" style={{ width: `${count}%` }} />
            </div>
        </div>
    );
}

export default UploadProgress;
